export const buildThresholdsInfo = threshold => [
  {
    range: `< ${threshold.threshold_lowest}`,
    status: {
      type: 'lowest',
      threshold_lowest: threshold.threshold_lowest,
    },
    description: threshold.message_lowest,
  },
  {
    range: `${threshold.threshold_lowest} - ${threshold.threshold_low}`,
    status: {
      type: 'low',
      threshold_lowest: threshold.threshold_lowest,
      threshold_low: threshold.threshold_low,
    },
    description: threshold.message_low,
  },
  {
    range: `${threshold.threshold_low} - ${threshold.threshold_high}`,
    status: {
      type: 'normal',
      threshold_low: threshold.threshold_low,
      threshold_high: threshold.threshold_high,
    },
    description: 'Normal',
  },
  {
    range: `${threshold.threshold_high} - ${threshold.threshold_highest}`,
    status: {
      type: 'high',
      threshold_high: threshold.threshold_high,
      threshold_highest: threshold.threshold_highest,
    },
    description: threshold.message_high,
  },
  {
    range: `> ${threshold.threshold_highest}`,
    status: {
      type: 'highest',
      threshold_highest: threshold.threshold_highest,
    },
    description: threshold.message_highest,
  },
];
